var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

//Main data accessing function. Reads the V in KLV
//Binary-parser does not support 64bits. Use @gmod/binary-parser
var Parser = require("@gmod/binary-parser").Parser;

var _require = require("./data/keys"),
    types = _require.types; //Will store unknown types


var unknown = new Set();
var valueParsers = {};

function getValueParserForType(type, opts) {
  var key = "".concat(type, "-").concat(JSON.stringify(opts));

  if (!valueParsers.hasOwnProperty(key)) {
    valueParsers[key] = new Parser().endianess("big")[types[type].func]("value", opts);
  }

  return valueParsers[key];
} //Refactor for performance/memory?


function parseV(environment, slice, len, specifics) {
  var data = environment.data,
      options = environment.options,
      ks = environment.ks;
  var _specifics$ax = specifics.ax,
      ax = _specifics$ax === void 0 ? 1 : _specifics$ax,
      _specifics$type = specifics.type,
      type = _specifics$type === void 0 ? ks.type : _specifics$type,
      complexType = specifics.complexType; //Split data when axes present

  if (ax > 1) {
    //Will return array of values
    var res = [];

    for (var i = 0; i < ax; i++) {
      var innerType = type; //Pick type from previously read data if needed

      if (types[type].complex) innerType = complexType[i]; //Log unknown types for future implementation

      if (!types[innerType]) {
        unknown.add(type);
        res.push(null);
      } else res.push(parseV(environment, slice + i * ks.size / ax, len / ax, {
        ax: 1,
        type: innerType,
        complexType: complexType
      }));
    } //If debugging, print unexpected types


    if (options.debug && unknown.size) setImmediate(function () {
      return console.warn("unknown types:", _toConsumableArray(unknown).join(","));
    });
    return res; //Otherwise, read a single value
  } else if (!types[type].complex) {
    //Add options required by type
    var opts = {
      length: len
    };
    if (types[type].opt) for (var key in types[type].opt) {
      opts[key] = types[type].opt[key];
    } //We pick the necessary function based on data format (stored in types)

    var valParser = getValueParserForType(type, opts);
    var parsed = valParser.parse(data.slice(slice)).result;
    return parsed.value; //Data is complex but did not find axes
  } else throw new Error("Complex type ? with only one axis");
}

module.exports = parseV;